<template>
  <div>
    <QHloading v-if="QHloading"></QHloading>
    <div class="QHpostionDaohang">
      <div class="box on">
        <span>{{$getCityFuqin('name')}}最近100条清运线路图</span>
        <div style="margin-bottom:10px;">
          <Select v-model="keywordKind" slot="prepend" placeholder="全局搜索">
            <Option value="">全局搜索</Option>
            <Option value="100">按起点地址</Option>
            <Option value="200">按工地名称</Option>
            <Option value="300">按联单编号</Option>
            <Option value="400">按接收单位</Option>
            <Option value="500">按车牌号码</Option>
          </Select>
        </div>
        <div class="flex-center">
          <Input v-model="keyword" placeholder="联单号/地址/车牌/单位"/>
          <div class="btn" @click="getData()">搜一搜</div>
        </div>
      </div>
    </div>
    <div class="QHzuobiaoMapPage" id="map"></div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      QHloading:true,
      keywordKind:"",
      keyword: "",
      searchShow: true,
      map: null,
      maskLayer: null,
    };
  },

  mounted() {
    this.getData();
  },

  methods: {
    //获取地图标记数据
    getData() {
      var that = this;
      var https = {
        type: "isApi",
        isLoading: "isLoadingPop",
        api: this.$api.getQingyunXianLu,
        parameter: {
          keywordKind:this.keywordKind,
          keyword: this.keyword,
        },
      };
      that.$httpsApi(https, function (res) {
        if(that.map){
          that.map.destroy();
        };
        //整合弧线数据
        var huxianData = that.getHuxianShuju(res.data);

        //整合弧线坐标
        var zuibiaodianData = that.getHuxianZuibiaoDian(res.data);

        //执行地图初始化
        that.mapInit(huxianData, zuibiaodianData);
      });
    },

    // +----------------------------------------------------------------------
    // | @Des整合弧线数据
    // +----------------------------------------------------------------------
    getHuxianShuju(huxianData) {
      var that = this;
      return huxianData.map((item, index) => {
        var coordinateA = that.$commaToarr(item["qingYunStartCoordinates"]);
        var coordinateB = that.$commaToarr(item["qingYunEndCoordinates"]);
        return {
          id: "huxian",
          from: {
            lat: parseFloat(coordinateA[0]),
            lng: parseFloat(coordinateA[1]),
          },
          to: {
            lat: parseFloat(coordinateB[0]),
            lng: parseFloat(coordinateB[1]),
          },
        };
      });
    },

    // +----------------------------------------------------------------------
    // | @Des整合弧线坐标点数据
    // +----------------------------------------------------------------------
    getHuxianZuibiaoDian(zuibiaoData) {
      var that = this;
      var length = zuibiaoData.length;
      var list = [];
      for (var i = 0; i < length; i++) {
        var value = zuibiaoData[i];
        var coordinateA = that.$commaToarr(value["qingYunStartCoordinates"]);
        var coordinateB = that.$commaToarr(value["qingYunEndCoordinates"]);

        //起点
        var obj = {};
        obj["markerId"] = "markerPaifang";
        obj["role"] = "排放点";
        obj["name"] = value["projectName"];
        obj["addressDetailed"] = value["qingYunStartAddressFull"];
        if (!that.$isblank(coordinateA) && coordinateA.length == 2) {
          obj["lat"] = parseFloat(coordinateA[0]);
          obj["lng"] = parseFloat(coordinateA[1]);
          list.push(obj);
        }

        //终点
        var obj = {};
        obj["markerId"] = "markerJieshou";
        obj["role"] = "接收点";
        obj["name"] = value["orgNameJieshou"];
        obj["addressDetailed"] = value["qingYunEndAddressFull"];
        if (!that.$isblank(coordinateB) && coordinateB.length == 2) {
          obj["lat"] = parseFloat(coordinateB[0]);
          obj["lng"] = parseFloat(coordinateB[1]);
          list.push(obj);
        }
      }
      return list;
    },

    // 地图初始化
    async mapInit(huxianData, zuibiaoData) {
      try {
        // 初始化地图
        this.initializeMap();
        // 加载行政区划数据
        const polygons = await this.loadDistrictPolygons();
        // 处理并显示行政区划
        this.processPolygons(polygons);
        // 创建坐标标记点
        this.createMarker(zuibiaoData);
        // 创建弧线
        setTimeout(() => {
          this.createHuxian(huxianData);
          this.QHloading = false;
        }, 500);
      } catch (error) {
        console.error("地图初始化失败:", error);
      }
    },

    // 创建地图弧线
    createHuxian(huxianData) {
      // 创建弧线图
      var arc = new TMap.visualization.Arc({
        mode: "horizontal", // 弧线平面与地平面平行
        pickStyle: function (arcLine) {
          // 样式映射函数
          var huxian = {
            opacity: 1,
            animatable: true,
            color: "#f66702",
            animateColor: "#ffffff",
          };
          return (arcLine.id = huxian);
        },
      }).addTo(this.map); // 通过addTo()添加到指定地图实例

      // 设置数据，若需要更新数据则再次调用setData方法即可
      arc.setData(huxianData);
    },

    // 创建地图坐标
    createMarker(polygon) {
      if (!this.map) {
        console.error("地图未初始化");
        return;
      }

      // 清除旧标记层（如果存在）
      if (this.markerLayer) {
        this.markerLayer.setMap(null);
      }

      // 创建新标记层
      this.markerLayer = new TMap.MultiMarker({
        map: this.map,
        cursor: "pointer",
        zIndex: 100,
        styles: {
          markerPaifang: new TMap.MarkerStyle({
            width: 25,
            height: 35,
            src: require("@/assets/PFD.png"),
            anchor: { x: 16, y: 32 },
          }),
          markerJieshou: new TMap.MarkerStyle({
            width: 25,
            height: 35,
            src: require("@/assets/JSD.png"),
            anchor: { x: 16, y: 32 },
          }),
        },
        geometries: polygon.map((point) => ({
          position: new TMap.LatLng(point.lat, point.lng),
          styleId: point.markerId,
          properties: {
            markerId: point.markerId,
            role: point.role,
            name: point.name,
            addressDetailed: point.addressDetailed,
          },
        })),
      });

      //初始化infoWindow
      var infoWindow = new TMap.InfoWindow({
        map: this.map,
        enableCustom: true,
        position: new TMap.LatLng(23.126419, 113.234015),
        //设置信息窗相对position偏移像素
        offset: {
          x: 0,
          y: 0,
        },
      });
      infoWindow.close(); //初始关闭信息窗关闭

      // 添加点击事件
      this.markerLayer
        .on("mouseover", (evt) => {
          infoWindow.open(); //打开信息窗
          infoWindow.setPosition(evt.geometry.position); //设置信息窗位置
          var properties = evt.geometry.properties;
          var html1 = '<div class="p1">' + properties.role + "</div>";
          var html2 = '<div class="p2">名称：' + properties.name + "</div>";
          var html3 = '<div class="p3">地址：' + properties.addressDetailed + "</div>";
          var html = '<div class="MultiMarker">' + html1 + html2 + html3 + "</div>";
          infoWindow.setContent(html); //设置信息窗内容
        })
        .on("mouseout", () => {
          infoWindow.close();
        });
    },

    // 初始化地图基础配置
    initializeMap() {
      this.map = new TMap.Map("map", {
        center: new TMap.LatLng(23.126419, 113.234015),
        showLabel: false,
        zoom: 10,
        mapStyleId: "style2",
        showControl: false,
        baseMap: {
          type: "vector",
          features: ["base", "building3d", "label", "building"],
        },
      });
    },

    // 加载行政区划数据
    async loadDistrictPolygons() {
      const district = new TMap.service.District({ polygon: 2 });
      var code = this.$FMTCode(this.$getCityFuqin("code"));
      if (this.$getCityFuqin("level") == 4) {
        var code = this.$FMTCode(this.$getUser("districtCode"));
      };
      const result = await district.search({ keyword: code });
      return new TMap.MultiPolygon({
        map: this.map,
        geometries: [],
      });
    },

    // 处理多边形数据
    processPolygons(polygons) {
      var code = this.$FMTCode(this.$getCityFuqin("code"));
      if (this.$getCityFuqin("level") == 4) {
        var code = this.$FMTCode(this.$getUser("districtCode"));
      };
      new TMap.service.District({ polygon: 2 }).search({ keyword: code }).then((result) => {
        result.result.forEach((level) => {
          level.forEach((place) => {
            // 生成多边形数据
            const geometries = place.polygon.map((polygon, index) => ({
              id: `${place.id}_${index}`,
              paths: polygon,
            }));

            // 更新多边形显示
            polygons.updateGeometries(geometries);

            // 计算并设置地图边界
            const bounds = this.calculateSafeBounds(place.polygon);
            this.map.fitBounds(bounds, { padding: 50 });

            // 创建遮罩层
            this.createMaskLayer(place.polygon);
          });
        });
      });
    },

    // 安全边界计算方法
    calculateSafeBounds(polygons) {
      // 初始化有效边界
      let swLat = 90,
        swLng = 180;
      let neLat = -90,
        neLng = -180;

      polygons.forEach((polygon) => {
        polygon.forEach((point) => {
          const lat = point.lat || point[0];
          const lng = point.lng || point[1];

          swLat = Math.min(swLat, lat);
          swLng = Math.min(swLng, lng);
          neLat = Math.max(neLat, lat);
          neLng = Math.max(neLng, lng);
        });
      });

      return new TMap.LatLngBounds(new TMap.LatLng(swLat, swLng), new TMap.LatLng(neLat, neLng));
    },

    // 创建区域镂空层
    createMaskLayer(targetPolygons) {
      if (this.maskLayer) {
        this.maskLayer.setMap(null);
      }

      // 转换所有多边形坐标并验证方向
      const processPolygon = (polygon) => {
        return polygon;
      };

      // 生成正确方向的外层路径（顺时针）
      var coverage = [new TMap.LatLng(-85, -180), new TMap.LatLng(-85, 180), new TMap.LatLng(85, 180), new TMap.LatLng(85, -180)];

      // 处理多个镂空区域
      const holes = targetPolygons
        .map((polygon) => {
          const validPolygon = processPolygon(polygon);
          if (validPolygon.length < 3) return null;
          return [...validPolygon].reverse(); // 逆时针
        })
        .filter((h) => h !== null);

      // 创建遮罩层
      try {
        this.maskLayer = new TMap.MultiPolygon({
          map: this.map,
          geometries: [
            {
              paths: [coverage, ...holes], // 合并所有路径
              styleId: "maskStyle",
            },
          ],
          styles: {
            maskStyle: new TMap.PolygonStyle({
              color: "rgba(0, 13, 57, 0.6)",
              showBorder: false,
              fillOpacity: 0.1,
              zIndex: 9999, // 设置层级高度，值越大越靠上
            }),
          },
          zIndex: 9999, // 设置层级高度，值越大越靠上
        });

        // 使用备用刷新方法
        setTimeout(() => {
          this.map.setCenter(this.map.getCenter());
          this.maskLayer.setZIndex(9999);
        }, 100);
      } catch (error) {
        console.error("遮罩层创建失败:", error);
      }
    },

    //生成覆盖可视区域的矩形
    createFullCoveragePolygon() {
      // 生成覆盖可视区域的矩形（考虑地图当前投影）
      const bounds = this.map.getBounds();
      return [bounds.getSouthWest(), new TMap.LatLng(bounds.getSouthWest().getLat(), bounds.getNorthEast().getLng()), bounds.getNorthEast(), new TMap.LatLng(bounds.getNorthEast().getLat(), bounds.getSouthWest().getLng())];
    },
  },

  //销毁地图
  beforeDestroy() {
    if (this.map) {
      this.map.destroy();
    }
  },
};
</script>
<style>
html{background: radial-gradient(circle, #0c96ff, #092654);}
.QHpostionDaohang .box {
  padding: 10px;
  font-size: 14px;
}
.QHpostionDaohang span {
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 10px;
  display: block;
}
.QHpostionDaohang .btn {
  background: #f48c0e;
  height:36px;
  line-height:36px;
  padding:0 5px;
  margin-left: 5px;
  border-radius: 5px;
  color: #fff;
  white-space: nowrap;
}
</style>
